import { PropsWithChildren } from 'react'

export function Title({ children }: PropsWithChildren) {
  return (
    <h2 className="mb-spacing4 text-large font-bold text-neutral600">
      {children}
    </h2>
  )
}
